
export function snapshotToObjects(snapshot) {
    if (snapshot.empty) {
        return [];
    }

    var objects = [];
    snapshot.forEach(function(doc) {
        var data = doc.data();
        if (data.id) {
            data.serverReservationObjectId = data.id
        }
        data.platformID = doc.id;
        data.id = doc.id
        objects.push(data);
    });

    return objects;
}